import { Injectable } from '@angular/core';
import { AlertController, App } from 'ionic-angular';
import 'rxjs/add/operator/map';

// Salvar no storage
import { Storage } from '@ionic/storage';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../api/api';

// Página de login
import { LoginPage } from '../../pages/login/login';
import { HomePage } from '../../pages/home/home';
import { MaisempresaPage } from '../../pages/home/home';

@Injectable()

export class AuthProvider {

	constructor(private storage: Storage, private _apiService: ApiProvider, private alertCtrl: AlertController, public app: App){}

	/* Verifica se o login esta ok ou se tem algum tipo de erro */
	confirmaLogin()
	{
		let nav = this.app.getActiveNav();

		// Retorna o id do usuario
		this.storage.get('id_cliente').then((id_usuario) => {
            // Chama a Api e verifica se tem alguma coisa
            this._apiService.verificaUsuario({id_usuario:id_usuario}).subscribe(arg => {
            	// Verifica se foi tudo certo
            	if(arg.erro === false)
            	{
            		return;
            	}
            	// Se for email manda para tela de email
            	else if(arg.erro == 'email')
            	{
            		let erro = this.alertCtrl.create({
			            enableBackdropDismiss: false,
			            title: 'Ops',
			            message: "Para continuar preencha seu e-mail.",
			            buttons: [
			            {
			                text: 'Ok',
			                handler: data => {
			                    // nav.setRoot(DadosPage);
			                }
			            }
			            ]
			        });
			        erro.present();
            	}
            	// Se for excluido desloga e manda para o inicio
            	else if(arg.erro == 'deletado')
            	{
            		let erro2 = this.alertCtrl.create({
			            enableBackdropDismiss: false,
			            title: 'Ops',
			            message: "O administrador removeu sua conta. Para mais detalhes entre em contato.",
			            buttons: [
			            {
			                text: 'Ok',
			                handler: data => {
			                	this.logout();
			                    nav.setRoot(LoginPage);
			                }
			            }
			            ]
			        });
			        erro2.present();
            	}
            	// Se foi um erro desconhecido
            	else
            	{
            		let erro3 = this.alertCtrl.create({
			            enableBackdropDismiss: false,
			            title: 'Ops',
			            message: "Parece que o sistema encontrou um erro. Por favor, entre em contato.",
			            buttons: [
			            {
			                text: 'Ok',
			                handler: data => {
			                	this.logout();
			                    nav.setRoot(LoginPage);
			                }
			            }
			            ]
			        });
			        erro3.present();
            	}
            })
        });
	}

	// Sair
	public logout()
	{
		this.storage.clear();
	}

	// verifica se tem a empresa
	public checkempresa()
	{
		let nav = this.app.getActiveNav();
		this.storage.get('id_empresa_escolhida').then((id) =>
        {
        	if((id == 0) || (id == null))
    		{
    			// nav.setRoot(nav.first());
    			nav.popToRoot();
    		}
        });
	}
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts